import { createAction } from 'redux-actions';

import { track } from 'ha/modules/Analytics/actions';
import reportError from 'ha/helpers/bugsnag/reportError';
import { send as showAlert } from 'ha/modules/Alertbar/actions';
import { Actions } from '../constants';
import { getSearchAlertParams } from '../selectors';

const flow = {
  start: createAction(Actions.CREATE_SEARCH_ALERT_START),
  done: createAction(Actions.CREATE_SEARCH_ALERT_DONE),
  error: createAction(Actions.CREATE_SEARCH_ALERT_ERROR),
};

export default ({ successText, errorText }) => (
  dispatch,
  getState,
  services,
) => {
  const state = getState();

  dispatch(flow.start());

  return services.apiV2
    .upsertSearchAlert(getSearchAlertParams(state))
    .then(response => {
      dispatch(showAlert({ text: successText, dismissAfter: 5000 }));
      dispatch(flow.done(response.data));
      dispatch(track('Search alert updated'));
    })
    .catch(error => {
      reportError(error, { metaData: error });
      dispatch(flow.error());
      dispatch(
        showAlert({ text: errorText, kind: 'danger', dismissAfter: 5000 }),
      );
    });
};
